import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaCheck, FaWhatsapp } from 'react-icons/fa';
import styles from './terapia_nutri_marimurra.module.scss';
import FotoBrincar from './src/terapia/brincar_cenoura.jpeg';
import FotoTocar from './src/terapia/tocar.jpeg';
import FotoBanana from './src/terapia/banana.jpeg';
import FotoRefeicao from './src/terapia/refeicao.jpeg';
import FotoPlano from './src/terapia/plano.jpeg';
import FotoCozinha from './src/terapia/cozinha_brinquedo.jpeg';
import { WHATSAPP_ONLINE, WHATSAPP_PRESENCIAL, getWhatsappUrl } from './dados_nutri_marimurra.ts';

const VIDEOS = [require('./src/terapia/video1.mp4') as string, require('./src/terapia/video2.mp4') as string];

const CORES = [styles.corLaranja, styles.corVerde, styles.corRosa, styles.corAmarelo];

const ETAPAS = ['Olha', 'Toca', 'Cheira', 'Prova', 'Come'];

const SINAIS = [
    'Come menos de 20 alimentos diferentes ou recusa grupos inteiros, como todas as frutas ou legumes.',
    'Está deixando de aceitar alimentos que comia.',
    'Perdeu peso ou não está crescendo como esperado.',
    'Chora, tem ânsia ou vomita diante de um alimento novo.',
    'Engasga com frequência, tem dificuldade para mastigar ou as refeições passam de 40 minutos.',
    'Passou a ter medo de comer depois de um engasgo ou vômito.',
    'Só aceita uma marca ou um único jeito de preparo.',
    'As refeições viraram brigas ou a família prepara um cardápio separado.',
];

const MENSAGEM = 'Olá, Mariana! Vim pelo Instagram e gostaria de agendar uma avaliação de terapia alimentar.';

const Terapia_nutri_marimurra: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.terapia_nutri_marimurra}>
            <header className={styles.topo}>
                <div className={styles.topoInner}>
                    <div className={styles.headerNav}>
                        <Link to="/nutri_marimurra" className={styles.backButton} aria-label="Voltar">
                            <FaArrowLeft />
                        </Link>
                    </div>

                    <figure className={styles.heroPhoto}>
                        <img src={FotoBrincar} alt="Criança brincando com cenouras durante a terapia alimentar" />
                        <figcaption>aprender brincando!</figcaption>
                    </figure>

                    <span className={styles.eyebrow}>Nutrição infantil</span>
                    <h1 className={styles.title}>Terapia alimentar</h1>
                    <p className={styles.lead}>
                        Muitas crianças recusam alimentos novos, e na maioria das vezes isso é uma fase. Em alguns
                        casos, porém, a recusa vai além e merece um olhar especializado.
                    </p>
                </div>
            </header>

            <div className={styles.page}>
                <section className={styles.section}>
                    <div className={styles.sectionHead}>
                        <span className={`${styles.sectionNumber} ${styles.corLaranja}`}>1</span>
                        <h2 className={styles.sectionTitle}>O que é a terapia alimentar</h2>
                    </div>
                    <p className={styles.paragraph}>
                        É um acompanhamento para crianças com dificuldade em aceitar ou experimentar alimentos.
                        Comer envolve os sentidos, a mastigação, o funcionamento do corpo e as emoções; quando algo
                        disso não vai bem, a criança passa a evitar a comida para se proteger.
                    </p>
                    <p className={styles.paragraph}>
                        Na terapia, a criança conhece o alimento aos poucos e por meio de brincadeiras:
                    </p>
                    <div className={styles.steps}>
                        {ETAPAS.map((etapa, index) => (
                            <span key={etapa} className={CORES[index % CORES.length]}>
                                {etapa}
                            </span>
                        ))}
                    </div>
                    <p className={styles.paragraph}>
                        Ninguém é forçado a comer, e a família participa de todo o processo.
                    </p>
                    <div className={styles.photoPair}>
                        <figure>
                            <img src={FotoTocar} alt="Criança tocando o alimento com as mãos" />
                            <figcaption>tocar</figcaption>
                        </figure>
                        <figure>
                            <img src={FotoBanana} alt="Criança explorando uma banana no prato" />
                            <figcaption>provar</figcaption>
                        </figure>
                    </div>
                </section>

                <section className={styles.section}>
                    <div className={styles.sectionHead}>
                        <span className={`${styles.sectionNumber} ${styles.corVerde}`}>2</span>
                        <h2 className={styles.sectionTitle}>Seletividade comum ou algo a mais?</h2>
                    </div>
                    <p className={styles.paragraph}>
                        Entre os 2 e os 6 anos é comum a criança desconfiar de alimentos novos. Na seletividade
                        comum, ela aceita alimentos de quase todos os grupos, cresce bem e, de vez em quando, prova
                        algo diferente. Quando a recusa passa a afetar a saúde, o crescimento ou a rotina da família,
                        é hora de procurar ajuda.
                    </p>
                    <img className={styles.wideImg} src={FotoRefeicao} alt="Criança comendo durante a refeição" />
                </section>

                <section className={styles.section}>
                    <div className={styles.sectionHead}>
                        <span className={`${styles.sectionNumber} ${styles.corRosa}`}>3</span>
                        <h2 className={styles.sectionTitle}>Quando me preocupar</h2>
                    </div>
                    <ul className={styles.checklist}>
                        {SINAIS.map((sinal, index) => (
                            <li key={sinal}>
                                <span className={`${styles.checkIcon} ${CORES[index % 2]}`}>
                                    <FaCheck aria-hidden />
                                </span>
                                <span>{sinal}</span>
                            </li>
                        ))}
                    </ul>
                    <p className={styles.highlight}>
                        Crianças com autismo, prematuras ou com histórico de sonda merecem atenção especial. Quanto
                        mais cedo a ajuda chega, mais simples tende a ser o caminho.
                    </p>
                </section>

                <section className={styles.section}>
                    <div className={styles.sectionHead}>
                        <span className={`${styles.sectionNumber} ${styles.corAmarelo}`}>4</span>
                        <h2 className={styles.sectionTitle}>Como funciona</h2>
                    </div>
                    <p className={styles.paragraph}>
                        Começamos com uma avaliação da história alimentar e da relação da criança com a comida. A
                        partir dela, montamos um plano com pequenos passos, trabalhados em sessões lúdicas, e
                        orientamos a família para as refeições em casa.
                    </p>
                    <p className={styles.paragraph}>
                        Quando necessário, atuamos em conjunto com pediatra, fonoaudiólogo, terapeuta ocupacional ou
                        psicólogo.
                    </p>
                    <div className={styles.photoPair}>
                        <figure>
                            <img src={FotoPlano} alt="Alimentos e utensílios preparados para a sessão" />
                            <figcaption>o plano</figcaption>
                        </figure>
                        <figure>
                            <img src={FotoCozinha} alt="Sessão lúdica com cozinha de brinquedo" />
                            <figcaption>a sessão</figcaption>
                        </figure>
                    </div>
                </section>

                <section className={styles.section}>
                    <div className={styles.sectionHead}>
                        <span className={`${styles.sectionNumber} ${styles.corLaranja}`}>5</span>
                        <h2 className={styles.sectionTitle}>Na prática</h2>
                    </div>
                    <div className={styles.videos}>
                        {VIDEOS.map((src) => (
                            <video
                                key={src}
                                className={styles.video}
                                src={src}
                                autoPlay
                                muted
                                loop
                                playsInline
                                controls
                                preload="metadata"
                            />
                        ))}
                    </div>
                </section>

                <section className={styles.cta}>
                    <h2 className={styles.sectionTitle}>Agende uma avaliação</h2>
                    <p className={styles.paragraph}>
                        Se você se identificou com algum desses sinais, entre em contato para agendar uma avaliação.
                    </p>
                    <div className={styles.ctaButtons}>
                        <a
                            href={getWhatsappUrl(WHATSAPP_PRESENCIAL, MENSAGEM)}
                            className={`${styles.button} ${styles.buttonLight}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaWhatsapp aria-hidden />
                            Avaliação presencial
                        </a>
                        <a
                            href={getWhatsappUrl(WHATSAPP_ONLINE, MENSAGEM)}
                            className={`${styles.button} ${styles.buttonOutline}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaWhatsapp aria-hidden />
                            Avaliação online
                        </a>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Terapia_nutri_marimurra;
